import { colors } from "@/styles/colors";
import { css, styled } from "@mui/material";


const StyledChatMessagesList = styled('ul')`
  margin: 0;
  margin-top: auto;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column-reverse;
  gap: 16px;

  .chat-messages {
    &__item {
      
    }
  }

  span.chat-messages__time-text {
    font-size: 10px;
  }
`;

const StyledTextMessage = styled('li')<{ isSender: boolean; isSkeleton?: boolean; }>`
  max-width: 75%;
  align-self: ${props => props.isSender ? 'flex-end' : 'flex-start'};
  padding: 8px;
  border-radius: ${props => props.isSender ? '10px 10px 0 10px' : '10px 10px 10px 0'};
  font-size: 15px;
  line-height: 1.5;
  background-color: ${props => props.isSender ? '#489FFF' : colors.secondary};
  color: ${props => props.isSender ? '#fff' : '#000'};
  font-family: "Inter" sans-serif;
  display: flex;
  align-items: flex-end;
  gap: 14px;

  ${props => props.isSkeleton ? css`
    background-color: transparent;
  ` : ``}
`;

const StyledLocationMessage = styled('li')``;

const StyledOfferMessage = styled('li')`
  width: 100%;
  align-self: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
`;


export {
  StyledChatMessagesList,
  StyledTextMessage,
  StyledOfferMessage,
  StyledLocationMessage
};
